module.exports = __webpack_public_path__ + "img/pablo-de-la-fuente.af39a9f9.jpg";